import { Empty } from 'antd'
import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import { lang } from './lang'

export default function EmptyUser() {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        <Text fontSize={14} fontType="body">
          <FormattedMessage {...lang.noUserFound} />
        </Text>
      }
    />
  )
}
